import styled from 'styled-components';

export default styled.img`
	height: 20px;
	cursor: pointer;
	@media (min-width: 576) {
		height: 25px;
	}
`;
